import { Link } from "@mui/material";
import { StyledLink } from "../../Styled";
import moment from "moment";
import CachedImage from "../../../../../../../common/CachedImage";


export const RenderCellContent = ({
    row,
    column,
    userDomain,
    userTimezone,
    defaultUserTimezone,
    handleAction = () => { },
    handleOnFieldAction = () => { },
}) => {

    if (!column || column.hidden) {
        return null;
    }

    switch (column.type) {
        case 'text_field':
        case 'text_area':
        case 'radiobutton':
        case 'dropdown':
        case 'multi_selection':
        case 'switch':
        case 'checkbox':
        case 'slider':
        case 'number':
        case 'lookup':
            if (!column.primaryKey) return column.value;

            const objValue = Object.values(row)[0].fields.map((col) => {
                objValue[col.id] = col.value;
                return col;
              });

            return (
                <StyledLink
                    onClick={() => handleAction('quickAction', objValue)}
                    userDomain={userDomain}
                >
                    {column.value}
                </StyledLink>
            );
        case 'password_field':
            return '*****';
        case 'buttons_field':
            if (column.options && column.options.length > 0) {
                return (
                    <>
                        {column?.options.map((item) => (
                            <Link key={item.label} onClick={() => handleOnFieldAction()}>
                                <span
                                    className={`${userDomain}_font`}
                                    style={{
                                        color: 'rgb(0, 189, 242)',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                    }}>
                                    {item.label}
                                </span>
                            </Link>
                        ))}
                    </>
                );
            };

            return (
                <Link onClick={() => handleOnFieldAction()}>
                    <span
                        className={`${userDomain}_font`}
                        style={{
                            color: 'rgb(0, 189, 242)',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}>
                        {column?.value?.text}
                    </span>
                </Link>
            );

        case 'image_field':
        case 'file_field':
            return column.fileName;
        case 'date':
            return moment(column.value)
                .tz(userTimezone || defaultUserTimezone)
                .format('ll');
        case 'time':
            return moment(column.value)
                .tz(userTimezone || defaultUserTimezone)
                .format('LT');
        case 'datetime':
            return moment(column.value)
                .tz(userTimezone || defaultUserTimezone)
                .format('lll');
        case 'alert_field':
            switch (column.value) {
                case 1:
                    return (
                        <div
                            style={{
                                boxSizing: 'border-box',
                                borderRadius: '4px',
                                height: ' 12px',
                                width: '12px',
                                backgroundColor: '#2DB757',
                            }} />
                    );
                case 2:
                    return (
                        <span>
                            <CachedImage
                                imgKey="warningIcon"
                                image="/images/warning@2x.png"
                                width="14px"
                            />
                        </span>
                    );
                case 3:
                    return (
                        <span>
                            <CachedImage
                                imgKey="errorIcon"
                                image="/images/error-icon@2x.png"
                                width="14px"
                            />
                        </span>
                    );
                default:
                    return column.value;
            }
        case 'object_multi_selection': {
            const opts = column.options;
            const vals = column.value;
            const dspfldArr = [];

            for (let i = 0; i < vals?.length; i += 1) {
                const selectedItm = opts?.find((opt) => opt?.value === vals[i]);
                if (selectedItm) {
                    // Directly push the selected item's display field to the array
                    // If it's the last item, add it as is; otherwise, append a comma.
                    dspfldArr.push(`${selectedItm?.displayField}${i === vals?.length - 1 ? '' : ', '}`);
                }
            };

            return (column.primaryKey || column.quickView) ? (
                <StyledLink
                    onClick={() => {
                        const objValue = {};
                        Object.values(row)[0].fields.map((col) => {
                            objValue[col.id] = col.value;
                            return col;
                        });
                        handleAction('quickAction', objValue);
                    }}
                    userDomain={userDomain}>
                    {dspfldArr}
                </StyledLink>
            ) : (
                dspfldArr
            );
        }
        default:
            return null;
    }
};